export class EtatOuvrage {
	constructor(
		public ouvrageId: number,
		public etat: String,
	) {
	}
}